import { types } from 'mobx-state-tree'
import { isLength } from 'validator'

import { FormStringFieldModel } from '../FormField/FormFieldModel'
import { IFormValidation } from '../FormField/FormValidation'

enum Salutations {
  EMPTY = '',
  MR = 'Mr.',
  MS = 'Ms.',
  NON_BINARY = 'Non-binary',
}

export const salutationsToTermMap: Record<Salutations, string> = {
  [Salutations.EMPTY]: 'directory-form_salutation_empty',
  [Salutations.MR]: 'directory-form_salutation_mr',
  [Salutations.MS]: 'directory-form_salutation_ms',
  [Salutations.NON_BINARY]: 'directory-form_salutation_non_binary',
}

export const salutationValues: string[] = Object.keys(Salutations).map((key) => Salutations[key])

export interface IBillingContact {
  salutation: Salutations
  firstName: string
  lastName: string
}

export const BillingContact = types
  .model('BillingContact', {
    salutation: FormStringFieldModel,
    firstName: FormStringFieldModel,
    lastName: FormStringFieldModel,
  })
  .views((self) => ({
    validateSalutation(): IFormValidation {
      return {
        isInvalid: salutationValues.indexOf(self.salutation.value) === -1,
        message: 'directory-validation_salutation',
      }
    },
    validateFirstName(): IFormValidation {
      return {
        // @ts-expect-error TS(2322) FIXME: Type 'string | boolean' is not assignable to type ... Remove this comment to see the full error message
        isInvalid: self.firstName.value && !isLength(self.firstName.value, { min: 1, max: 255 }),
        message: 'directory-validation_first_name',
      }
    },
    validateLastName(): IFormValidation {
      return {
        // @ts-expect-error TS(2322) FIXME: Type 'string | boolean' is not assignable to type ... Remove this comment to see the full error message
        isInvalid: self.lastName.value && !isLength(self.lastName.value, { min: 1, max: 255 }),
        message: 'directory-validation_last_name',
      }
    },
  }))
  .views((self) => ({
    get isValid(): boolean {
      return (
        self.salutation.isDirty &&
        self.firstName.isDirty &&
        self.lastName.isDirty &&
        !self.validateSalutation().isInvalid &&
        !self.validateFirstName().isInvalid &&
        !self.validateLastName().isInvalid
      )
    },
  }))
  .actions((self) => ({
    setSalutation(salutation: string): void {
      self.salutation.setValue(salutation)
    },
    setFirstName(name: string): void {
      self.firstName.setValue(name)
    },
    setLastName(name: string): void {
      self.lastName.setValue(name)
    },
    validate(): void {
      self.salutation.isDirty = true
      self.firstName.isDirty = true
      self.lastName.isDirty = true
    },
    reset(): void {
      self.salutation.isDirty = false
      self.firstName.isDirty = false
      self.lastName.isDirty = false
    },
  }))
